export const GET_INCOMING = 'GET_INCOMING';
export const GET_INCOMING_SUCCESS = 'GET_INCOMING_SUCCESS';
export const GET_INCOMING_FAIL = 'GET_INCOMING_FAIL';

export const GET_INCOMING_UPDATE = 'GET_INCOMING_UPDATE';

export const GET_INCOMING_ACCEPT = 'GET_INCOMING_ACCEPT';
export const GET_INCOMING_ACCEPT_SUCCESS = 'GET_INCOMING_ACCEPT_SUCCESS';
export const GET_INCOMING_ACCEPT_FAIL = 'GET_INCOMING_ACCEPT_FAIL';

export const GET_INCOMING_REJECT = 'GET_INCOMING_REJECT';
export const GET_INCOMING_REJECT_SUCCESS = 'GET_INCOMING_REJECT_SUCCESS';
export const GET_INCOMING_REJECT_FAIL = 'GET_INCOMING_REJECT_FAIL';

export const GET_INCOMING_LIST_AREAS = 'GET_INCOMING_LIST_AREAS';
export const GET_INCOMING_LIST_AREAS_SUCCESS = 'GET_INCOMING_LIST_AREAS_SUCCESS';
export const GET_INCOMING_LIST_AREAS_FAIL = 'GET_INCOMING_LIST_AREAS_FAIL';

export const GET_INCOMING_LIST_BOXES = 'GET_INCOMING_LIST_BOXES';
export const GET_INCOMING_LIST_BOXES_SUCCESS = 'GET_INCOMING_LIST_BOXES_SUCCESS';
export const GET_INCOMING_LIST_BOXES_FAIL = 'GET_INCOMING_LIST_BOXES_FAIL';

export const GET_INCOMING_LIST_STOCKS = 'GET_INCOMING_LIST_STOCKS';
export const GET_INCOMING_LIST_STOCKS_SUCCESS = 'GET_INCOMING_LIST_STOCKS_SUCCESS';
export const GET_INCOMING_LIST_STOCKS_FAIL = 'GET_INCOMING_LIST_STOCKS_FAIL';

export const GET_INCOMING_ERROR_FALSE = 'GET_INCOMING_ERROR_FALSE';

export const GET_INCOMING_CLEAR = 'GET_INCOMING_CLEAR';

export const SET_INITIAL_STATE_INCOMING = 'SET_INITIAL_STATE_INCOMING';
